class VehicleTransportModel{
    vehicleTransportId:number;
    name?:string;
    contactPerson?: string;
    mobile?: string;
    alternateMobile?:string;
    address?:string;
    isActive?:boolean;
  
    
    
}
export default VehicleTransportModel;